import type { MemberSelection } from '@/types/weekly-selections';

interface FamilyMemberCardProps {
  member: MemberSelection;
}

export function FamilyMemberCard({ member }: FamilyMemberCardProps) {
  return (
    <div className="bg-white rounded-lg shadow-md p-6">
      {/* Member name */}
      <h3 className="text-lg font-semibold text-gray-900 mb-4">
        {member.userName}
      </h3>

      {/* Selections list */}
      {member.selections.length === 0 ? (
        <p className="text-sm text-gray-500 italic">
          Pas de sélection
        </p>
      ) : (
        <ul className="space-y-2">
          {member.selections.map((selection) => (
            <li key={selection.mealId} className="text-sm text-gray-700">
              <span className="font-medium">{selection.mealName}</span>
              {selection.selectionCount > 1 && (
                <span className="text-gray-500 ml-2">
                  × {selection.selectionCount}
                </span>
              )}
            </li>
          ))}
        </ul>
      )}

      {/* Total count */}
      <div className="mt-4 pt-4 border-t border-gray-200">
        <p className="text-sm text-gray-600">
          Total : {member.totalSelections} repas
        </p>
      </div>
    </div>
  );
}
